import React from 'react';
import { useSelector } from 'react-redux';

import { getCountries, getCountriesIsFetching } from 'modules/countries/selectors';
import { getCountryTranslations } from 'modules/i18n/selectors/data';

const useCountries = ({ valueField, overriddenOptions }) => {
  const countries = useSelector(getCountries);
  const loading = useSelector(getCountriesIsFetching);
  const translations = useSelector(getCountryTranslations);

  const formatted = React.useMemo(() => Object.values(countries).reduce((acc, country) => {
    const { code, name, [valueField]: value } = country;
    const allowed = !Array.isArray(overriddenOptions) || overriddenOptions.includes(code);

    if (allowed) {
      return [
        ...acc,
        {
          ...country,
          label: translations[code] ?? name,
          'data-cy': `country-${value}`,
        },
      ];
    }

    return acc;
  }, []), [countries, translations, valueField, overriddenOptions]);

  return React.useMemo(() => ({
    loading,
    formatted: formatted.toSorted((a, b) => a.label.localeCompare(b.label)),
  }), [formatted, loading]);
};

export default useCountries;
